import { Col, Row, Select, SelectProps } from 'antd';
import { useTranslation } from 'react-i18next';

import styles from './DoughnutBoxTitleWithComparator.module.css';

interface DoughnutBoxTitleWithComparatorProps extends SelectProps {
  title?: string;
}

const DoughnutBoxTitleWithComparator: React.FC<DoughnutBoxTitleWithComparatorProps> = ({
  title,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <Col>
      <Row justify="center">{title || t('Comparar com outro arquétipo')}</Row>
      <Row justify="center">
        <Select className={styles.title__select} allowClear {...props} />
      </Row>
    </Col>
  );
};

export default DoughnutBoxTitleWithComparator;
